"use client";

let pending = 0;
const listeners = new Set<() => void>();
export function isAuthTransitionPending(): boolean {
  return pending > 0;
}
export function subscribeAuthTransition(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
/** Pause chat until verification, server handoff and browser session installation finish. */
export function beginAuthTransition(): () => void {
  pending += 1;
  listeners.forEach((listener) => listener());
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    pending -= 1;
    listeners.forEach((listener) => listener());
  };
}
